@if (customer) {
  <span>{{ customer.email }}</span>
} @else {
  <span class="label label-default">N/A</span>
}
